module.exports = "/assets/data/24e645405260ea6d7741b69abdfd610c-TS23.data.json";